import type {
  TDisplayDateSource,
  TResourceDateValue
} from './displayDate.types';

const firstNonEmpty = (values: TResourceDateValue[]) => {
  for (const value of values) {
    if (value) return value;
  }
  return '';
};

export const resolveDisplayDate = (source: TDisplayDateSource) => {
  return firstNonEmpty([
    source.displayDate,
    source.publishedDate,
    source.publishedAt,
    source.createdAt
  ]);
};
